<template>
	<tabbed-page-layout class="sales" title="Salg" :pages="pages" />
</template>

<script>
    export default {
		props: ['pages']
    }
</script>

<style lang="scss">

</style>